import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { FETCH_PRODUCT_LIST_REQUEST, EPIC_ERROR } from 'Constants/redux';
import service from 'Api/service';
import { receiveProductList } from 'Actions';

const fetchProductListEpic = (action$) =>
  action$.pipe(
    ofType(FETCH_PRODUCT_LIST_REQUEST),
    debounceTime(500),
    switchMap((action) =>
      from(
        service.post(
          `${import.meta.env.VITE_API_DOMAIN}/api/products/list`,
          action.options
        )
      ).pipe(
        map((response) => receiveProductList(response.data.products)),
        catchError((error) => {
          console.error('fetchProductListEpic error', error);
          return of({ type: EPIC_ERROR });
        })
      )
    )
  );

export default fetchProductListEpic;
